import React, { useEffect, useState } from 'react';
import { Button, Flex, message, Space, Spin, Typography } from 'antd';
import { AppstoreOutlined, PlusOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import useDeviceStore from '../../stores/device.store';
import { devicePath, summaryDevicePath } from '../../routes';
import './DevicePage.scss';
import CreateModalDevice from '../../components/device/CreateModalDevice/CreateModalDevice';
import DeviceGeneralTable from '../../components/general/DevicesGeneralTable';
import { Device } from '../../gen/proto/api/gateway/v1/gateway_pb';

const { Title } = Typography;
const DATA_PAGE_SIZE = 15;

function DevicePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [isCreateDeviceModalOpen, setIsCreateDeviceModalOpen] = useState(false);

  const [deviceList, setDeviceList] = useState<Device[]>([]);
  const [page, setPage] = useState(0);

  const getListByPagination = useDeviceStore((state) => state.getListByPagination);
  const createDevice = useDeviceStore((state) => state.create);
  const totalData = useDeviceStore((state) => state.totalEntities);
  const deleteDevice = useDeviceStore((state) => state.delete);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getListByPagination(page, DATA_PAGE_SIZE);
        setDeviceList(response);
      } catch (error) {
        messageApi.error('Error cargando los dispositivos');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [page, getListByPagination, messageApi]);

  function onRowClick(record: Device) {
    const path = location.pathname.split('/').slice(0, 2).join('/');
    navigate(`${path}/${devicePath}/${record.uuid}/${summaryDevicePath}`);
  }

  async function onCreateDevice(name: string, type: string) {
    try {
      const newDevice = await createDevice(name, type);
      setDeviceList((prevDevices) => [...prevDevices, newDevice]);
      setIsCreateDeviceModalOpen(false);
    } catch (error) {
      messageApi.error('Error creando el dispositivo');
    }
  }

  async function onDeleteDevice(uuid: string) {
    try {
      await deleteDevice(uuid);
      setDeviceList((prevDevices) => prevDevices.filter((device) => device.uuid !== uuid));
      messageApi.success('Dispositivo eliminado correctamente');
    } catch (error) {
      messageApi.error('Error eliminando el dispositivo');
    }
  }

  return (
    <Flex vertical className={'DevicePage'}>
      {contextHolder}
      <Spin spinning={loading} size={'large'} fullscreen={true} style={{ zIndex: 999 }} />
      <CreateModalDevice
        open={isCreateDeviceModalOpen}
        onCancel={() => setIsCreateDeviceModalOpen(false)}
        handleSubmit={onCreateDevice}
      />
      <Space className={'DevicePage__row'}>
        <Space size={'middle'}>
          <AppstoreOutlined className={'DevicePage__icon'} />
          <Title level={1} className={'DevicePage__title'}>
            Dispositivos
          </Title>
        </Space>
        <div className={'DevicePage__buttons'}>
          <Button type={'primary'} onClick={() => setIsCreateDeviceModalOpen(true)}>
            <PlusOutlined />
            Crear
          </Button>
        </div>
      </Space>
      <br />
      <div className={'DevicePage__table'}>
        <DeviceGeneralTable
          data={deviceList}
          onRowClick={onRowClick}
          pagination={{
            pageSize: DATA_PAGE_SIZE,
            total: totalData,
            current: page + 1,
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          onChange={(pagination) => {
            setPage((pagination.current ?? 1) - 1);
          }}
          onDeleteDevice={onDeleteDevice}
        />
      </div>
    </Flex>
  );
}

export default DevicePage;
